import { render, staticRenderFns } from "./TableTent.vue?vue&type=template&id=ebcaad40&scoped=true"
import script from "./TableTent.vue?vue&type=script&lang=js"
export * from "./TableTent.vue?vue&type=script&lang=js"
import style0 from "./TableTent.vue?vue&type=style&index=0&id=ebcaad40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_65uhlok3ryww266g2rjqqwj3cm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcaad40",
  null
  
)

export default component.exports